import { render } from "./EmployerRegistration.vue?vue&type=template&id=7991b58f&ts=true"
import script from "./EmployerRegistration.vue?vue&type=script&lang=ts"
export * from "./EmployerRegistration.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__